import { HSNData } from "../../../../Utils/AllPagesQuriesAndMutations";
const data = [
  {
    id: Math.random() * 10,
    name: "Bill_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Doc_Date",
        label: "Bill Date",
        type: "Date",

        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "CashOrDebit",
        label: "C/D",
        type: "inputdrop",
        dropdowndata: ["Debit", "Cash"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Book_Code",
        label: "Book Code",
        // dropdowndata: GetBookCodes,
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Bill No",
        type: "number",
        min: 5,
        max: 5,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Type",
        label: "Bill For",
        type: "inputdrop",
        dropdowndata: ["THC"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Inv_Type",
        label: "Inv. Type",
        type: "inputdrop",
        dropdowndata: ["Tax Invoice", "Bill Of Supply", "Retail Invoice", "Other", "Performence Invoice"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Tax_Code",
        label: "HSN",
        type: "InputDropForQuery",
        dropdowndata: HSNData,
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Account",
        label: "Account",
        type: "InputDropForQuery",

        min: 0,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Tax_Type",
      //   label: "Tax Type",
      //   type: "text",

      //   min: 0,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Sales_Account",
      //   label: "Sales Ac.",
      //   type: "text",

      //   min: 0,
      //   max: Infinity,
      // },

      {
        id: Math.random() * 10,
        name: "Party",
        label: "Party",
        type: "InputDropForQuery",

        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Get_Only_Bill_Party",
        label: "Get Only Bill Party?",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
    ],
  },
];
const DocUpload = {
  Imagefileds: [
    {
      id: Math.random() * 10,
      name: "File",
      label: "",
    },
  ],
};

const initialState = [
  {
    _id: Math.random() * 10,
    Name: "CGST ON LR",
    Expense_Account: { Account_Name: "CGST(O/P)" },
    At_Percentage: 0,
    Rate: 0,
    Amount: 0,
  },
  {
    _id: Math.random() * 10,
    Name: "SGST ON LR",
    Expense_Account: { Account_Name: "SGST(O/P)" },
    At_Percentage: 0,
    Rate: 0,
    Amount: 0,
  },
  // {
  //   _id: Math.random() * 10,
  //   Name: "IGST ON LR",
  //   Expense_Account: { Account_Name: "IGST(O/P)" },
  //   At_Percentage: 0,
  //   Rate: 0,
  //   Amount: 0,
  // },
  {
    _id: Math.random() * 10,
    Name: "Round Off",
    At_Percentage: 0,
    Expense_Account: { Account_Name: "DISCOUNT A/C" },
    Rate: 0,
    Amount: 0,
  },
];
export { data, DocUpload, initialState };

export const FreightBillConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Vendor Freight Bill",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
       {
        id: Math.random() * 10,
        name: "Discount_Account",
        label: "Discount Account",
        type: "InputDropForQuery",
        variable: {
          accountType: ["General Account"],
        },
        masterName: "General_Account",
      },
      {
        id: Math.random() * 10,
        name: "DefaultApplyRoundOff",
        label: "Default RoundOff",
        type: "Check-Box",
      },
    ],
  },
];
export const FreightBillVoucherNumnerConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Vendor Freight Bill",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "number",

        min: 5,
        max: 5,
      },
    ],
  },
];

export const Freight_Bill_Documents = [
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "File",
        label: "File",
      },
    ],
  },
];
